"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../utils/constants");
var muiDistribute16 = {
    paths: [
        {
            path: 'M2,2 L2,6 L12,6 L12,2 L2,2 Z M12.9931545,0 C13.5492199,0 14,0.453036308 14,0.997030139 L14,7.00296986 C14,7.5536144 13.5500512,8 12.9931545,8 L1.00684547,8 C0.450780073,8 0,7.54696369 0,7.00296986 L0,0.997030139 C0,0.446385598 0.449948758,0 1.00684547,0 L12.9931545,0 Z M7,2 C5.8954305,2 5,2.8954305 5,4 C5,5.1045695 5.8954305,6 7,6 C8.1045695,6 9,5.1045695 9,4 C9,2.8954305 8.1045695,2 7,2 Z M12.9931545,14 C13.509501,14 13.9350657,14.3827202 13.9932262,14.8826674 L14,15 C14,15.5522847 13.5500512,16 12.9931545,16 L1.00684547,16 C0.450780073,16 0,15.5561352 0,15 C0,14.4477153 0.449948758,14 1.00684547,14 L12.9931545,14 Z M12.9931545,10 C13.509501,10 13.9350657,10.3827202 13.9932262,10.8826674 L14,11 C14,11.5522847 13.5500512,12 12.9931545,12 L1.00684547,12 C0.450780073,12 0,11.5561352 0,11 C0,10.4477153 0.449948758,10 1.00684547,10 L12.9931545,10 Z M7,0 C9.209139,0 11,1.790861 11,4 C11,6.209139 9.209139,8 7,8 C4.790861,8 3,6.209139 3,4 C3,1.790861 4.790861,0 7,0 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Distribute',
    width: 16,
    height: 16,
};
var muiDistribute24 = {
    paths: [
        {
            path: 'M6.00064404,0.251869235 L6,10 L15.7480579,9.99963918 C14.8600978,13.4502767 11.7278088,16 8,16 C3.581722,16 0,12.418278 0,8 C0,4.27208922 2.54986283,1.13973081 6.00064404,0.251869235 Z',
            fill: constants_1.defaultFill,
        },
        {
            path: 'M8,0 C12.418278,0 16,3.581722 16,8 L16,8 L8,8 Z M10.0006859,2.34165389 L9.999,6 L13.6587023,6.00032181 C13.0562696,4.29557178 11.7052966,2.94438161 10.0006859,2.34165389 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Distribute',
    width: 21,
    height: 21,
};
var muiDistribute = {
    base: muiDistribute16,
    smIcon: muiDistribute16,
    lgIcon: muiDistribute24,
};
exports.muiDistribute = muiDistribute;
//# sourceMappingURL=distribute.js.map